import { z } from 'zod';
import { isValidIsoDate } from '../dates';

export const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD')
  .refine(isValidIsoDate, 'Invalid date');

export const uuid = z.uuid();

export const isoDateTime = z.iso.datetime({ offset: true });

/** Trimmed non-empty text up to `max` characters. */
export const text = (max: number) => z.string().trim().min(1).max(max);

/** Optional text: empty strings become null. */
export const optText = (max: number) =>
  z.preprocess(
    (v) => (typeof v === 'string' && v.trim() === '' ? null : v),
    z.string().trim().max(max).nullish(),
  );

export const santim = (min = 0, max = 1_000_000_000) => z.number().int().min(min).max(max);

/** Client fields every synced record carries (G-5). Server-owned fields are never part of these schemas (G-8). */
export const clientCreatedAt = isoDateTime.optional();

/** Server-owned fields (G-8) plus sync bookkeeping. Stripped from every client payload. */
export const SERVER_OWNED_FIELDS = [
  'tenantId',
  'createdAt',
  'updatedAt',
  'createdBy',
  'updatedBy',
  'serverSeq',
  'lateEntry',
  'uploadedAt',
  'deletedAt',
  'id',
] as const;

/** Sync block fields present on every synced record on the wire and in the device database. */
export interface SyncFields {
  id: string;
  tenantId?: string;
  createdBy: string;
  updatedBy: string;
  clientCreatedAt: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  serverSeq?: number;
}
